import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import {
  monitorResults,
  testResults
} from '../../docs-routes'
import {
  useConfigTypeTitle,
  useModule
} from '@eggplant/routing'

const TestResults = () => {
  const configTypeText = useConfigTypeTitle(true)
  const [isMonitorFlag] = useModule()

  return (
    <Paragraph>
      <Color variant='theme-description-text'>
        {configTypeText} Results shows an overview of results from your test runs. You also can view full details of tests and download logs from this area.
      </Color>
      <DocusaurusFooter
        path={
          isMonitorFlag
            ? monitorResults
            : testResults
        }
      />
    </Paragraph>
  )
}

export default TestResults
